/**
 * Platform Admin → AI Usage: the platform-wide OpenAI budget, spend and activation controls.
 */

import AiBudgetPanel from '@/components/admin/AiBudgetPanel';

export default function PlatformAiUsagePage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">AI Usage</h1>
        <p className="mt-1 text-sm text-gray-600">The platform-wide budget for optional AI guidance in PCI readiness, shared by all organizations.</p>
      </div>
      <AiBudgetPanel />
    </div>
  );
}
